export default "__VITE_ASSET__1f8c56ea__"